var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  var BLANK = '',
  { all_geos, selected_geos, search_area } = options,
  count_first_geo_slot = true;

__p+='\n\n<div class="selected-geos" id="selected-geos">\n    <div id="selected-geos-wrapper" class="selected-geos-wrapper">\n      ';
 if (search_area) { 
__p+='\n        <div class="selected-tag"> \n            <label  class="unselect">\n              <span>\n                '+
((__t=( search_area ))==null?'':__t)+
'\n              </span>\n            </label>\n        </div>\n      ';
 } 
__p+='\n      ';
 selected_geos.forEach((geo, index) => { 
__p+='\n        ';
 
          index = index + 2; // count of label begins at 2 
          let neighborhood = geo['neighborhood' + index] ? (geo['neighborhood' + index]).substr(0, (geo['neighborhood' + index]).lastIndexOf("-")) : null,
              postal_code  = geo['postal_code' + index],
              city         = geo['city' + index];
          let geoName = neighborhood ? neighborhood : postal_code ? postal_code : city;
        
__p+='\n        <div class="selected-tag" data-label="'+
((__t=( geo[`id${index}`] ))==null?'':__t)+
'"> \n            <label for="nearby-checkbox-'+
((__t=( geo[`id${index}`] ))==null?'':__t)+
'" class="unselect">\n              <span>\n                '+
((__t=( geoName ))==null?'':__t)+
'\n              </span>\n              <i class="ra ra-x-close"></i>\n            </label>\n        </div>\n      ';
 }) 
__p+='\n    </div>\n</div>\n \n<div class="nearby-areas-container">\n  ';
 all_geos.forEach((item, index) => { 
__p+='\n    ';
 if(index < 4 && !item.checked && count_first_geo_slot) { 
__p+='\n      ';
 count_first_geo_slot = false 
__p+='\n      <div class="geo-separation">\n          '+
((__t=( `Within ${Math.ceil(item.distance)} miles` ))==null?'':__t)+
'\n        </div>\n    ';
 } 
__p+='\n    ';
 if (item.prepend && item.prepend.message) { 
__p+='\n      <div class="geo-separation '+
((__t=( item.checked ? 'checked' : BLANK ))==null?'':__t)+
'">\n        '+
((__t=( item.prepend.message ))==null?'':__t)+
'\n      </div>\n    ';
 } 
__p+='\n    <div class="checkbox checkbox-primary '+
((__t=( item.checked ? 'checked' : BLANK ))==null?'':__t)+
'">\n      <input id="nearby-checkbox-'+
((__t=( item.id ))==null?'':__t)+
'" value="'+
((__t=( item.id ))==null?'':__t)+
'" type="checkbox" name="checkbox-nearby-areas-'+
((__t=( item.id ))==null?'':__t)+
'" '+
((__t=( item.checked ? "checked" : BLANK ))==null?'':__t)+
'>\n      <label for="nearby-checkbox-'+
((__t=( item.id ))==null?'':__t)+
'">\n        <span class="ellipsis">'+
((__t=( item.label ))==null?'':__t)+
'</span>\n      </label>\n    </div>\n  ';
 }) 
__p+='\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./srp/views/optimizely/multi_geo/geos_checkboxes.jst.ejs